export const OpenPayService = {
  merchantId: process.env.REACT_APP_OPENPAY_MERCHANTID,
  publicKey: process.env.REACT_APP_OPENPAY_APIKEY,
  isSandbox: process.env.REACT_APP_IS_SANDBOX === 'true',

  loadScript: () => {
    return new Promise((resolve, reject) => {
      if (window.OpenPay) {
        OpenPayService.initOpenPay();
        resolve();
        return;
      }

      const script = document.createElement('script');
      script.src = 'https://resources.openpay.mx/lib/openpay-js/1.2.38/openpay.v1.min.js';
      script.async = true;
      
      script.onload = () => {
        const dataScript = document.createElement('script');
        dataScript.src = 'https://resources.openpay.mx/lib/openpay-data-js/1.2.38/openpay-data.v1.min.js';
        
        dataScript.onload = () => {
          OpenPayService.initOpenPay();
          resolve();
        };
        
        dataScript.onerror = () => reject(new Error('Error al cargar OpenPay Data'));
        document.body.appendChild(dataScript);
      };
      
      script.onerror = () => reject(new Error('Error al cargar OpenPay'));
      document.body.appendChild(script);
    });
  },

  initOpenPay: () => {
    if (window.OpenPay) {
      window.OpenPay.setId(OpenPayService.merchantId);
      window.OpenPay.setApiKey(OpenPayService.publicKey);
      window.OpenPay.setSandboxMode(OpenPayService.isSandbox);
    } else {
    }
  },

  createToken: (cardData) => {
    return new Promise((resolve, reject) => {
      if (!window.OpenPay) {
        return reject(new Error('OpenPay no está cargado. Recarga la página.'));
      }

      const [month, year] = cardData.expiry.split('/').map(s => s.trim());
      
      // Validaciones adicionales
      if (!month || !year || month.length !== 2 || year.length !== 2) {
        return reject(new Error('Formato de fecha inválido. Use MM/AA'));
      }

      const currentYear = new Date().getFullYear() % 100;
      const expiryYear = parseInt(year);
      
      if (expiryYear < currentYear) {
        return reject(new Error('La tarjeta está vencida'));
      }

      const tokenRequest = {
        "card_number": cardData.number.replace(/\s/g, ''),
        "holder_name": cardData.name.toUpperCase().trim(),
        "expiration_year": year,
        "expiration_month": month.padStart(2, '0'),
        "cvv2": cardData.cvv.trim()
      };

      window.OpenPay.token.create(
        tokenRequest,
        (response) => {
          resolve(response.data);
        },
        (error) => {
          
          let errorMsg = 'Error al procesar la tarjeta. ';
          
          if (error.data?.description) {
            errorMsg += error.data.description;
          } else if (error.message) {
            errorMsg += error.message;
          } else {
            errorMsg += 'Verifica los datos e intenta de nuevo.';
          }
          
          reject(new Error(errorMsg));
        }
      );
    });
  },

  getDeviceSessionId: () => {
    try {
      if (window.OpenPay && window.OpenPay.deviceData) {
        const sessionId = window.OpenPay.deviceData.setup();
        return sessionId;
      }
    } catch (e) {
    }
    
    const fallbackId = `device_${Date.now()}_${Math.random().toString(36).substr(2, 9)}`;
    return fallbackId;
  }
};